import { Segment } from '@app/models/micro/segment.model';

export interface LegEndpoints {
  origin: string;
  destination: string;
}

export function getLegEndpoints(segments: Segment[] | undefined): LegEndpoints | null {
  if (!segments?.length) return null;

  const origin = segments[0]?.departureAirport;
  const destination = segments[segments.length - 1]?.arrivalAirport;

  if (!origin || !destination) return null;

  return { origin, destination };
}

export function isHiddenStopLeg(segments: Segment[] | undefined): boolean {
  const endpoints = getLegEndpoints(segments);
  if (!endpoints || !segments || segments.length < 2) return false;

  return !segments.some(
    (s) => s.departureAirport === endpoints.origin && s.arrivalAirport === endpoints.destination
  );
}
